import i18next from "i18next";

/**
 * Localization keys for API / Service Management (React).
 * Reuses global BridgeGate keys where they exist; API_SVC_* for module-specific strings.
 */
export const K = {
  // Reused global keys
  BTN_CANCEL: "BTN_CANCEL",
  BTN_NEXT: "BTN_NEXT",
  BTN_APPLY: "BTN_APPLY",
  BTN_YES: "BTN_YES",
  BTN_NO: "BTN_NO",
  BTN_CLEAR: "BTN_CLEAR",
  BTN_CREATE_NEW_IN_TEM: "BTN_CREATE_NEW_IN_TEM",
  BTN_CREATE_NEW_OUT_TEM: "BTN_CREATE_NEW_OUT_TEM",
  GET_DATA: "GET_DATA",
  TRANSLATE_DATA: "TRANSLATE_DATA",
  SEND_DATA: "SEND_DATA",
  INBOUND_TEMPLATE: "INBOUND_TEMPLATE",
  OUTBOUND_TEMPLATE: "OUTBOUND_TEMPLATE",
  WORKFLOW_GROUP: "WORKFLOW_GROUP",
  WORKFLOW: "WORKFLOW",
  WARNING: "WARNING",
  LBL_DATA_MAPPING: "LBL_DATA_MAPPING_",
  ACCOUNT: "ACCOUNT",
  STATUS: "STATUS",
  TOKEN: "TOKEN",
  CREATED_DATE: "CREATED_DATE",
  ALL: "ALL",
  SELECT: "SELECT",
  LBL_FROM: "LBL_FROM",
  LBL_TO: "LBL_TO",
  LBL_VALUE: "LBL_VALUE",
  LBL_NAME: "LBL_NAME",
  LBL_STATUS: "LBL_STATUS",
  LBL_ACTIONS: "LBL_ACTIONS",
  BOX_MSG_NAME_REQUIRED: "BOX_MSG_NAME_REQUIRED",
  BOX_MAX_LENGTH_FOR_NAME_IS: "BOX_MAX_LENGTH_FOR_NAME_IS",
  BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES:
    "BOX_TEM_NAMES_CANNOT_CONTAIN_CERTAIN_CHARS_OR_SPACES",
  API_SERVICE_MANAGER_WINDOW: "API_SERVICE_MANAGER_WINDOW",
  API_SERVICE_MANAGEMENT_PERMISSIONS: "API_SERVICE_MANAGEMENT_PERMISSIONS",

  // API Service Management — module keys
  API_SVC_TAB_OVERVIEW: "API_SVC_TAB_OVERVIEW",
  API_SVC_TAB_PERFORMANCE: "API_SVC_TAB_PERFORMANCE",
  API_SVC_WIZARD_BREADCRUMB_CREATE: "API_SVC_WIZARD_BREADCRUMB_CREATE",
  API_SVC_WIZARD_BREADCRUMB_STEP1: "API_SVC_WIZARD_BREADCRUMB_STEP1",
  API_SVC_WIZARD_BREADCRUMB_TRANSLATE: "API_SVC_WIZARD_BREADCRUMB_TRANSLATE",
  API_SVC_WORKFLOW_ITEMS: "API_SVC_WORKFLOW_ITEMS",
  API_SVC_GET_DATA_FROM_FILE: "API_SVC_GET_DATA_FROM_FILE",
  API_SVC_API_SERVICE_TYPE: "API_SVC_API_SERVICE_TYPE",
  API_SVC_API_SERVICE_VERSION: "API_SVC_API_SERVICE_VERSION",
  API_SVC_WF_NAME: "API_SVC_WF_NAME",
  API_SVC_NO_WF_GROUPS: "API_SVC_NO_WF_GROUPS",
  API_SVC_LOADING_WF_GROUPS: "API_SVC_LOADING_WF_GROUPS",
  API_SVC_BASE_URL: "API_SVC_BASE_URL",
  API_SVC_BASE_URL_HELP: "API_SVC_BASE_URL_HELP",
  API_SVC_CUSTOM_URL: "API_SVC_CUSTOM_URL",
  API_SVC_CONFORMANCE: "API_SVC_CONFORMANCE",
  API_SVC_EXECUTE_WITHIN: "API_SVC_EXECUTE_WITHIN",
  API_SVC_EXECUTE_WITHIN_PLACEHOLDER: "API_SVC_EXECUTE_WITHIN_PLACEHOLDER",
  API_SVC_EXECUTE_WITHIN_MS: "API_SVC_EXECUTE_WITHIN_MS",
  API_SVC_EXECUTE_WITHIN_SEC: "API_SVC_EXECUTE_WITHIN_SEC",
  API_SVC_EXECUTE_WITHIN_MIN: "API_SVC_EXECUTE_WITHIN_MIN",
  API_SVC_AND: "API_SVC_AND",
  API_SVC_HAS_NO_ERRORS: "API_SVC_HAS_NO_ERRORS",
  API_SVC_VALIDATING: "API_SVC_VALIDATING",
  API_SVC_REQUIRED: "API_SVC_REQUIRED",
  API_SVC_SELECT_WF_GROUP: "API_SVC_SELECT_WF_GROUP",
  API_SVC_SELECT_INBOUND: "API_SVC_SELECT_INBOUND",
  API_SVC_SELECT_OUTBOUND: "API_SVC_SELECT_OUTBOUND",
  API_SVC_SELECT_WF_GROUP_OPTION: "API_SVC_SELECT_WF_GROUP_OPTION",
  API_SVC_SELECT_INBOUND_OPTION: "API_SVC_SELECT_INBOUND_OPTION",
  API_SVC_SELECT_OUTBOUND_OPTION: "API_SVC_SELECT_OUTBOUND_OPTION",
  API_SVC_LOADING_INBOUND: "API_SVC_LOADING_INBOUND",
  API_SVC_LOADING_OUTBOUND: "API_SVC_LOADING_OUTBOUND",
  API_SVC_OPTIONAL_STEP: "API_SVC_OPTIONAL_STEP",
  API_SVC_TRANSLATE_NOW_PROMPT: "API_SVC_TRANSLATE_NOW_PROMPT",
  API_SVC_CANCEL_WARNING: "API_SVC_CANCEL_WARNING",
  API_SVC_NO_SAVE_CANCEL: "API_SVC_NO_SAVE_CANCEL",
  API_SVC_YES_CANCEL: "API_SVC_YES_CANCEL",
  API_SVC_CUSTOM_URL_DRAWER: "API_SVC_CUSTOM_URL_DRAWER",
  API_SVC_CUSTOM_URL_FROM_PLACEHOLDER: "API_SVC_CUSTOM_URL_FROM_PLACEHOLDER",
  API_SVC_CUSTOM_URL_TO_PLACEHOLDER: "API_SVC_CUSTOM_URL_TO_PLACEHOLDER",
  API_SVC_CUSTOM_URL_FROM_HELP: "API_SVC_CUSTOM_URL_FROM_HELP",
  API_SVC_CUSTOM_URL_TO_HELP: "API_SVC_CUSTOM_URL_TO_HELP",
  API_SVC_CUSTOM_URL_PUBLIC_PREVIEW: "API_SVC_CUSTOM_URL_PUBLIC_PREVIEW",
  API_SVC_CUSTOM_URL_STEP1_HELP: "API_SVC_CUSTOM_URL_STEP1_HELP",
  API_SVC_CUSTOM_URL_QUERY_WITHOUT_PATH: "API_SVC_CUSTOM_URL_QUERY_WITHOUT_PATH",
  API_SVC_NORMALIZED_EXECUTE_KEY: "API_SVC_NORMALIZED_EXECUTE_KEY",
  API_SVC_ADDITIONAL_PARAMS: "API_SVC_ADDITIONAL_PARAMS",
  API_SVC_PARAM_NAME_PLACEHOLDER: "API_SVC_PARAM_NAME_PLACEHOLDER",
  API_SVC_PARAM_VALUE_PLACEHOLDER: "API_SVC_PARAM_VALUE_PLACEHOLDER",
  API_SVC_ADD_PARAM: "API_SVC_ADD_PARAM",
  API_SVC_DELETE_PARAM: "API_SVC_DELETE_PARAM",
  API_SVC_CLEAR_ALL: "API_SVC_CLEAR_ALL",
  API_SVC_VALIDATING_ELLIPSIS: "API_SVC_VALIDATING_ELLIPSIS",
  API_SVC_GO_TO_MAPPING: "API_SVC_GO_TO_MAPPING",
  API_SVC_CONTINUE_WIZARD: "API_SVC_CONTINUE_WIZARD",
  API_SVC_GO_BACK_WIZARD: "API_SVC_GO_BACK_WIZARD",
  API_SVC_BTN_MAPPING: "API_SVC_BTN_MAPPING",
  API_SVC_BTN_PREVIOUS: "API_SVC_BTN_PREVIOUS",
  API_SVC_BTN_SAVE: "API_SVC_BTN_SAVE",
  API_SVC_BTN_CREATING: "API_SVC_BTN_CREATING",
  API_SVC_BTN_SAVING: "API_SVC_BTN_SAVING",
  API_SVC_CREATING_WORKFLOW: "API_SVC_CREATING_WORKFLOW",
  API_SVC_SAVING_API: "API_SVC_SAVING_API",
  API_SVC_WAIT_DO_NOT_CLOSE: "API_SVC_WAIT_DO_NOT_CLOSE",
  API_SVC_WAIT_CREATING: "API_SVC_WAIT_CREATING",
  API_SVC_ACCOUNT_REQUIRED: "API_SVC_ACCOUNT_REQUIRED",
  API_SVC_WF_REQUIRED: "API_SVC_WF_REQUIRED",
  API_SVC_NO_WF_TO_SAVE: "API_SVC_NO_WF_TO_SAVE",
  API_SVC_SAVE_FAILED: "API_SVC_SAVE_FAILED",
  API_SVC_SAVE_SUCCESS: "API_SVC_SAVE_SUCCESS",
  API_SVC_SAVE_REQUEST_FAILED: "API_SVC_SAVE_REQUEST_FAILED",
  API_SVC_CREATE_WF_FAILED: "API_SVC_CREATE_WF_FAILED",
  API_SVC_STEP1_FAILED: "API_SVC_STEP1_FAILED",
  API_SVC_EXECUTE_WITHIN_RANGE: "API_SVC_EXECUTE_WITHIN_RANGE",
  API_SVC_EXECUTE_WITHIN_WHOLE: "API_SVC_EXECUTE_WITHIN_WHOLE",
  API_SVC_SERVICE_NOT_AVAILABLE: "API_SVC_SERVICE_NOT_AVAILABLE",
  API_SVC_DUPLICATE_SERVICE: "API_SVC_DUPLICATE_SERVICE",
  API_SVC_WF_EXISTS: "API_SVC_WF_EXISTS",
  API_SVC_WF_NOT_AVAILABLE: "API_SVC_WF_NOT_AVAILABLE",
  API_SVC_WF_VALIDATE_FAILED: "API_SVC_WF_VALIDATE_FAILED",
  API_SVC_VALIDATE_SERVICE_FAILED: "API_SVC_VALIDATE_SERVICE_FAILED",
  API_SVC_VALIDATE_URL_FAILED: "API_SVC_VALIDATE_URL_FAILED",
  API_SVC_CUSTOM_URL_INVALID: "API_SVC_CUSTOM_URL_INVALID",
  API_SVC_CUSTOM_URL_IN_USE: "API_SVC_CUSTOM_URL_IN_USE",
  API_SVC_SAVE_WF_FAILED: "API_SVC_SAVE_WF_FAILED",
  API_SVC_SAVE_WF_SERVER_FAILED: "API_SVC_SAVE_WF_SERVER_FAILED",
  API_SVC_UPDATE_METADATA_FAILED: "API_SVC_UPDATE_METADATA_FAILED",
  API_SVC_ENABLE_SERVICE_FAILED: "API_SVC_ENABLE_SERVICE_FAILED",
  API_SVC_SAVE_PREREQ: "API_SVC_SAVE_PREREQ",
  API_SVC_CREATE_API: "API_SVC_CREATE_API",
  API_SVC_BLANK_TITLE: "API_SVC_BLANK_TITLE",
  API_SVC_BLANK_BODY: "API_SVC_BLANK_BODY",
  API_SVC_LOADING_APIS: "API_SVC_LOADING_APIS",
  API_SVC_API_COUNT: "API_SVC_API_COUNT",
  API_SVC_API_COUNT_PLURAL: "API_SVC_API_COUNT_PLURAL",
  API_SVC_PAGE_OF: "API_SVC_PAGE_OF",
  API_SVC_SEARCH_PLACEHOLDER: "API_SVC_SEARCH_PLACEHOLDER",
  API_SVC_ADVANCED_SEARCH: "API_SVC_ADVANCED_SEARCH",
  API_SVC_CLEAR_FILTER: "API_SVC_CLEAR_FILTER",
  API_SVC_FILTER_LIST: "API_SVC_FILTER_LIST",
  API_SVC_ADVANCED_FILTERS: "API_SVC_ADVANCED_FILTERS",
  API_SVC_FILTERS: "API_SVC_FILTERS",
  API_SVC_COL_ADAPTER: "API_SVC_COL_ADAPTER",
  API_SVC_COL_AUTHORIZATION: "API_SVC_COL_AUTHORIZATION",
  API_SVC_COL_LAST_EXECUTED: "API_SVC_COL_LAST_EXECUTED",
  API_SVC_COL_VERSION: "API_SVC_COL_VERSION",
  API_SVC_SEARCH_LIMIT: "API_SVC_SEARCH_LIMIT",
  API_SVC_STATUS_ENABLED: "API_SVC_STATUS_ENABLED",
  API_SVC_STATUS_DISABLED: "API_SVC_STATUS_DISABLED",
  API_SVC_CHIP_ENABLED: "API_SVC_CHIP_ENABLED",
  API_SVC_CHIP_DISABLED: "API_SVC_CHIP_DISABLED",
  API_SVC_NO_PERMISSION_VIEW: "API_SVC_NO_PERMISSION_VIEW",
  API_SVC_ACCOUNT_MISSING: "API_SVC_ACCOUNT_MISSING",
  API_SVC_STATUS_UPDATE_FAILED: "API_SVC_STATUS_UPDATE_FAILED",
  API_SVC_STATUS_ENABLED_TOAST: "API_SVC_STATUS_ENABLED_TOAST",
  API_SVC_STATUS_DISABLED_TOAST: "API_SVC_STATUS_DISABLED_TOAST",
  API_SVC_DELETE_FAILED: "API_SVC_DELETE_FAILED",
  API_SVC_DELETE_SUCCESS: "API_SVC_DELETE_SUCCESS",
  API_SVC_DELETE_TITLE: "API_SVC_DELETE_TITLE",
  API_SVC_DELETE_CONFIRM: "API_SVC_DELETE_CONFIRM",
  API_SVC_BTN_DELETE: "API_SVC_BTN_DELETE",
  API_SVC_COMING_SOON: "API_SVC_COMING_SOON",
  API_SVC_MENU_DETAILS: "API_SVC_MENU_DETAILS",
  API_SVC_DETAILS_TITLE: "API_SVC_DETAILS_TITLE",
  API_SVC_CLOSE_DETAILS: "API_SVC_CLOSE_DETAILS",
  API_SVC_DETAILS_FAILED: "API_SVC_DETAILS_FAILED",
  API_SVC_DETAILS_SUMMARY: "API_SVC_DETAILS_SUMMARY",
  API_SVC_SERVICE_KEY: "API_SVC_SERVICE_KEY",
  API_SVC_REMAINING_COUNT: "API_SVC_REMAINING_COUNT",
  API_SVC_CLUSTER_DETAILS_TITLE: "API_SVC_CLUSTER_DETAILS_TITLE",
  API_SVC_CLUSTER_DETAILS_EMPTY: "API_SVC_CLUSTER_DETAILS_EMPTY",
  API_SVC_WORKFLOW_COMMENTS: "API_SVC_WORKFLOW_COMMENTS",
  API_SVC_MENU_PERFORMANCE: "API_SVC_MENU_PERFORMANCE",
  API_SVC_MENU_WORKFLOW: "API_SVC_MENU_WORKFLOW",
  API_SVC_MENU_EDIT: "API_SVC_MENU_EDIT",
  API_SVC_MENU_VIEW: "API_SVC_MENU_VIEW",
  API_SVC_MENU_EXEC_HISTORY: "API_SVC_MENU_EXEC_HISTORY",
  API_SVC_MENU_DISABLE: "API_SVC_MENU_DISABLE",
  API_SVC_MENU_ENABLE: "API_SVC_MENU_ENABLE",
  API_SVC_MENU_DELETE: "API_SVC_MENU_DELETE",
  API_SVC_EXECUTING: "API_SVC_EXECUTING",
  API_SVC_NA: "API_SVC_NA",
  API_SVC_REMAINING_TOOLTIP: "API_SVC_REMAINING_TOOLTIP",
  API_SVC_ROW_ACTIONS: "API_SVC_ROW_ACTIONS",
  API_SVC_EXEC_HISTORY_TITLE: "API_SVC_EXEC_HISTORY_TITLE",
  API_SVC_CLOSE_EXEC_HISTORY: "API_SVC_CLOSE_EXEC_HISTORY",
  API_SVC_EXEC_HISTORY_SHOWING: "API_SVC_EXEC_HISTORY_SHOWING",
  API_SVC_EXEC_HISTORY_EMPTY: "API_SVC_EXEC_HISTORY_EMPTY",
  API_SVC_EXEC_HISTORY_FAILED: "API_SVC_EXEC_HISTORY_FAILED",
  API_SVC_NO_FILTER_MATCH: "API_SVC_NO_FILTER_MATCH",
  API_SVC_TABLE_PAGINATION: "API_SVC_TABLE_PAGINATION",
  API_SVC_TXN_SEARCH: "API_SVC_TXN_SEARCH",
  API_SVC_PERF_TITLE: "API_SVC_PERF_TITLE",
  API_SVC_PERF_BODY: "API_SVC_PERF_BODY",
  API_SVC_PERF_SELECTED: "API_SVC_PERF_SELECTED",
  API_SVC_PERF_DATE_RANGE_TOOLTIP: "API_SVC_PERF_DATE_RANGE_TOOLTIP",
  API_SVC_PERF_FILTER_BY: "API_SVC_PERF_FILTER_BY",
  API_SVC_PERF_CLEAR_FILTERS: "API_SVC_PERF_CLEAR_FILTERS",
  API_SVC_PERF_QUANTITY: "API_SVC_PERF_QUANTITY",
  API_SVC_PERF_CHART_SOURCE: "API_SVC_PERF_CHART_SOURCE",
  API_SVC_PERF_CHART_OUTLIERS: "API_SVC_PERF_CHART_OUTLIERS",
  API_SVC_PERF_Y_TRANSACTIONS: "API_SVC_PERF_Y_TRANSACTIONS",
  API_SVC_PERF_Y_VIOLATIONS: "API_SVC_PERF_Y_VIOLATIONS",
  API_SVC_PERF_X_API: "API_SVC_PERF_X_API",
  API_SVC_PERF_SOURCE: "API_SVC_PERF_SOURCE",
  API_SVC_PERF_REQUESTS: "API_SVC_PERF_REQUESTS",
  API_SVC_PERF_TOTAL_REQUESTS: "API_SVC_PERF_TOTAL_REQUESTS",
  API_SVC_PERF_TOTAL_VIOLATIONS: "API_SVC_PERF_TOTAL_VIOLATIONS",
  API_SVC_PERF_EXEC_TIME_ERRORS: "API_SVC_PERF_EXEC_TIME_ERRORS",
  API_SVC_PERF_EXEC_TIME: "API_SVC_PERF_EXEC_TIME",
  API_SVC_PERF_VALIDATION: "API_SVC_PERF_VALIDATION",
  API_SVC_PERF_TRANSLATION: "API_SVC_PERF_TRANSLATION",
  API_SVC_PERF_ERRORS: "API_SVC_PERF_ERRORS",
  API_SVC_PERF_TOTAL_ERRORS: "API_SVC_PERF_TOTAL_ERRORS",
  API_SVC_PERF_WORKFLOW_ERRORS: "API_SVC_PERF_WORKFLOW_ERRORS",
  API_SVC_PERF_NO_DATA: "API_SVC_PERF_NO_DATA",
  API_SVC_PERF_NO_OUTLIERS: "API_SVC_PERF_NO_OUTLIERS",
  API_SVC_PERF_LOAD_FAILED: "API_SVC_PERF_LOAD_FAILED",
  API_SVC_PERF_LOADING: "API_SVC_PERF_LOADING",
  API_SVC_PERF_SINGULAR_TXN_CHART: "API_SVC_PERF_SINGULAR_TXN_CHART",
  API_SVC_PERF_SINGULAR_VIOL_CHART: "API_SVC_PERF_SINGULAR_VIOL_CHART",
  API_SVC_PERF_X_SOURCE: "API_SVC_PERF_X_SOURCE",
  API_SVC_PERF_CONFORMING: "API_SVC_PERF_CONFORMING",
  API_SVC_PERF_NON_CONFORMING: "API_SVC_PERF_NON_CONFORMING",
  API_SVC_CLOSE_SINGULAR_VIEW: "API_SVC_CLOSE_SINGULAR_VIEW",
  API_SVC_PERF_SINGULAR_MISSING_CONTEXT: "API_SVC_PERF_SINGULAR_MISSING_CONTEXT",
  API_SVC_PREV_PAGE: "API_SVC_PREV_PAGE",
  API_SVC_NEXT_PAGE: "API_SVC_NEXT_PAGE",
  API_SVC_EM_DASH: "API_SVC_EM_DASH",
  API_SVC_ADAPTER_AS2: "API_SVC_ADAPTER_AS2",
  API_SVC_ADAPTER_MSMQ: "API_SVC_ADAPTER_MSMQ",
  API_SVC_ADAPTER_HTTP: "API_SVC_ADAPTER_HTTP",
  API_SVC_ADAPTER_KAFKA: "API_SVC_ADAPTER_KAFKA",
  API_SVC_ADAPTER_FTP: "API_SVC_ADAPTER_FTP",
  API_SVC_ADAPTER_FILE: "API_SVC_ADAPTER_FILE",
  API_SVC_ADAPTER_WEBSERVICE: "API_SVC_ADAPTER_WEBSERVICE",
  API_SVC_ADAPTER_SOCKET: "API_SVC_ADAPTER_SOCKET",
  API_SVC_ADAPTER_MQSERIES: "API_SVC_ADAPTER_MQSERIES",
  API_SVC_DESCRIPTION: "API_SVC_DESCRIPTION",

  // Edit / View API page
  API_SVC_EDIT_TITLE: "API_SVC_EDIT_TITLE",
  API_SVC_VIEW_TITLE: "API_SVC_VIEW_TITLE",
  API_SVC_BTN_APPLYING: "API_SVC_BTN_APPLYING",
  API_SVC_BTN_MODIFY_WORKFLOW: "API_SVC_BTN_MODIFY_WORKFLOW",
  API_SVC_BTN_CLOSE: "API_SVC_BTN_CLOSE",
  API_SVC_EDIT_LOAD_FAILED: "API_SVC_EDIT_LOAD_FAILED",
  API_SVC_APPLY_SUCCESS: "API_SVC_APPLY_SUCCESS",
  API_SVC_APPLY_FAILED: "API_SVC_APPLY_FAILED",
  API_SVC_URL_CHANGE_TITLE: "API_SVC_URL_CHANGE_TITLE",
  API_SVC_URL_CHANGE_BODY: "API_SVC_URL_CHANGE_BODY",
  API_SVC_URL_CHANGE_CONFIRM: "API_SVC_URL_CHANGE_CONFIRM",
  API_SVC_COPY_BASE_URL: "API_SVC_COPY_BASE_URL",
  API_SVC_COPY_CUSTOM_URL: "API_SVC_COPY_CUSTOM_URL",
};

/** BridgeGate .properties use Java MessageFormat `{0}`; i18next defaults to `{{name}}`. */
function applyJavaMessageFormat(text, options) {
  if (!options || typeof text !== "string") return text;
  let result = text;
  for (const [key, value] of Object.entries(options)) {
    if (!/^\d+$/.test(String(key))) continue;
    const token = `{${key}}`;
    result = result.split(token).join(String(value ?? ""));
  }
  return result;
}

/** Translate a property key (for use outside React components). */
export function apiT(key, options) {
  return applyJavaMessageFormat(i18next.t(key, options), options);
}

/** MUI label: strip trailing colon from legacy LBL_* keys. */
export function apiLabel(key, options) {
  return apiT(key, options).replace(/:$/, "").trim();
}

/** Adapter type → display label key. */
export const ADAPTER_LABEL_KEYS = {
  AS2: K.API_SVC_ADAPTER_AS2,
  BridgeGateMSMQ: K.API_SVC_ADAPTER_MSMQ,
  BridgeGateHTTP: K.API_SVC_ADAPTER_HTTP,
  Kafka: K.API_SVC_ADAPTER_KAFKA,
  BridgeGateFTP: K.API_SVC_ADAPTER_FTP,
  FILE: K.API_SVC_ADAPTER_FILE,
  BridgeGateWebService: K.API_SVC_ADAPTER_WEBSERVICE,
  BridgeGateSocket: K.API_SVC_ADAPTER_SOCKET,
  BridgeGateMQSeries: K.API_SVC_ADAPTER_MQSERIES,
};

export function getAdapterTypeLabel(value, t = apiT) {
  const key = ADAPTER_LABEL_KEYS[value];
  return key ? t(key) : value;
}
